export function initSalesSpecialistSlides(){
  const slides = document.querySelectorAll('.sales-specialist-recruited_candidates_slide')
  const slideButtons = document.querySelectorAll('.sales-specialist-recruited_candidates_slide_buttons span')

  let current_slide = 0;
  setCurrentSlideButton(current_slide)

  slides.forEach(function(slide, index){
    slide.style.left = `${index * 100}%`
  })

  slideButtons.forEach(function(button, index){
    button.addEventListener('click', function(e){
      e.preventDefault
      current_slide = index;
      moveSlides(current_slide)
    })
  })

  setInterval(nextSlide, 9000)


  function moveSlides(index){
    slides.forEach(function(slide){
      slide.style.transform = `translateX(-${index * 100}%)`
    })
    setCurrentSlideButton(index)
  }

  function nextSlide(){
    if(current_slide == slides.length){ current_slide = 0 }

    moveSlides(current_slide++)
  }

  function setCurrentSlideButton(index){
    slideButtons.forEach(function(button){
      button.classList.remove('current_slide') 
    })
    if(slideButtons[index]){
      slideButtons[index].classList.toggle('current_slide')
    }
  }

}

document.addEventListener("turbolinks:load", function(event) {
  initSalesSpecialistSlides()
})
